import React, { FC } from 'react';
import { Controller, FieldError } from 'react-hook-form';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { FormElement } from 'src/front/components/FormStyles';
import { Combobox, Option } from '@code/innovance-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';

interface Props {
  countries: Option[];
  disabled?: boolean;
  formMethods: UseFormMethods<IdentityFormData>;
  onChangeHandler: (option: Option | null) => void;
}
const IssueCountry: FC<Props> = ({ countries, disabled, formMethods, onChangeHandler }) => {
  const { control, errors } = formMethods;
  const { t } = useTranslation();
  return (
    <FormElement>
      <Controller
        control={control}
        name="issueCountry"
        render={({ onChange, value }) => (
          <Combobox
            disabled={disabled ?? false}
            errorMessage={t((errors?.issueCountry as FieldError)?.message as string)}
            items={countries}
            label={t('general_country_label')}
            name="issueCountry"
            onChange={(option) => {
              onChange(option);
              onChangeHandler(option);
            }}
            searchPlaceholder={t('cardEntry_documentEntry_searchCountry_text')}
            value={value}
            required
            searchable
          />
        )}
      />
    </FormElement>
  );
};

export default IssueCountry;
